var _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDarkMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8584 13.4221C28.9679 13.535 29.0537 13.6678 29.1111 13.813C29.1732 13.9597 29.2058 14.1168 29.2072 14.2756H17.6553L14.4533 14.241C14.4533 14.241 12.6843 14.2855 11.3347 14.2855H5.30732H0.000176719C-0.00264447 14.1268 0.0283404 13.9692 0.0911565 13.8229C0.152168 13.676 0.243347 13.5429 0.359041 13.432L4.98131 8.90682L7.95332 5.99973L13.7154 0.356273C13.8293 0.243064 13.965 0.153087 14.1147 0.0915425C14.2655 0.0313284 14.4269 0.00024345 14.5898 0C14.7518 0.000561492 14.9123 0.0316405 15.0624 0.0915425C15.2128 0.153032 15.3494 0.242996 15.4642 0.356273L21.2768 6.03189L24.2917 8.96867L28.8584 13.4221Z",
    fill: "url(#paint0_linear_4355_34962)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8776 15.6123L15.4682 23.7877C15.2274 24.0247 14.9222 24.1392 14.5947 24.1392C14.2672 24.1392 13.9531 24.0128 13.7212 23.7877L5.3017 15.6123H5.96119e-05C-0.00154757 15.7699 0.0293583 15.9261 0.090945 16.0718C0.151894 16.2177 0.242978 16.3499 0.358551 16.4601L13.7237 29.437C13.8367 29.551 13.9725 29.6414 14.1226 29.7024C14.2729 29.7638 14.4342 29.7955 14.5972 29.7958C14.7603 29.7959 14.9217 29.7642 15.0719 29.7024C15.222 29.6414 15.3578 29.551 15.4707 29.437L28.8485 16.4601C28.9641 16.3493 29.0559 16.2173 29.1187 16.0718C29.1795 15.926 29.2095 15.7697 29.207 15.6123H23.8776Z",
    fill: "url(#paint1_linear_4355_34962)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1032 24.0564C14.8918 24.6906 16.6891 26.1584 17.9179 27.0825C17.9122 27.0574 15.2357 29.8401 15.0797 29.9052C14.9295 29.9678 14.768 30 14.6049 29.9999C14.4418 29.9996 14.2804 29.9674 14.13 29.9052C13.9798 29.8432 13.844 29.7516 13.7309 29.636L0.358739 16.4723C0.243105 16.3605 0.151973 16.2264 0.0909926 16.0784C0.0293737 15.9306 -0.00154838 15.7721 5.96431e-05 15.6123H5.30447L13.4797 23.5672C13.6631 23.7302 14.0115 24.0202 14.1032 24.0564Z",
    fill: "url(#paint2_linear_4355_34962)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M18.9184 26.1029C18.8921 26.1288 17.9297 27.0771 17.9297 27.0771L16.0254 25.5978L14.1577 24.0825L15.4876 24.5394L17.5106 25.3491L19.0911 25.9719C19.0911 25.9719 18.9917 26.0308 18.9184 26.1029Z",
    fill: "url(#paint3_linear_4355_34962)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4355_34962",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7335 13.3504C28.8425 13.4616 28.9279 13.5925 28.9851 13.7355C29.0469 13.8801 29.0794 14.0349 29.0807 14.1914H17.5789L14.3907 14.1573C14.3907 14.1573 12.6293 14.2012 11.2857 14.2012H5.28435H0.000175954C-0.00263302 14.0448 0.0282177 13.8895 0.0907619 13.7453C0.15151 13.6006 0.242294 13.4694 0.357487 13.3601L4.95975 8.90127L7.91889 6.03679L13.656 0.476051C13.7694 0.364501 13.9045 0.275843 14.0536 0.215201C14.2038 0.155869 14.3644 0.12524 14.5266 0.125C14.688 0.125553 14.8477 0.156177 14.9972 0.215201C15.1469 0.275789 15.2829 0.364434 15.3972 0.476051L21.1847 6.06849L24.1866 8.96222L28.7335 13.3504Z",
    fill: "url(#paint4_linear_4355_34962)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4355_34962)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0766,
    height: 17.4367,
    transform: "matrix(0.734061 -0.679083 0.717801 0.696249 -0.878906 13.418)",
    fill: "url(#paint5_linear_4355_34962)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4355_34962",
    x1: 9.15344,
    y1: 7.98713,
    x2: 21.0994,
    y2: 14.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4355_34962",
    x1: 14.6036,
    y1: 15.6123,
    x2: 14.6036,
    y2: 29.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5712F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4355_34962",
    x1: 7.61002,
    y1: 15.6123,
    x2: 7.61002,
    y2: 29.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4141F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC9FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4355_34962",
    x1: 16.2462,
    y1: 26.2833,
    x2: 17.0262,
    y2: 25.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F187C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4137CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4355_34962",
    x1: 9.11382,
    y1: 7.99506,
    x2: 20.9467,
    y2: 14.8272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#343761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4355_34962",
    x1: 5.03835,
    y1: 9.74895,
    x2: 13.2176,
    y2: 11.8565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C7DF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkMobile);
export default __webpack_public_path__ + "static/media/logoDarkMobile.7bce7b1cb19e9ad83ec1838d588cf30b.svg";
export { ForwardRef as ReactComponent };